
import * as React from 'react';
import { connect } from 'react-redux';
import { assign as _assign } from 'lodash';

import {
  LoginModel,
  GlobalState,
  formatMessage,
} from 'src/api';

import {
  loginFormValues,
} from 'src/api/models/Login/login.class';

import {
  createForm, FormWrappedComponentProps, CreateFormProps
} from 'src/api/models/Form/Form'

import {
  loadAuthentification,
  AuthentificationData
} from 'loopback-react-request';

import { ActivationResend } from '../Activation/ActivationResend';

import MESSAGES from './LoginForm.messages';

import './LoginForm.scss';

export const LoginFormResult = (props: FormWrappedComponentProps<LoginModel>) => {
  const {
    requestError,
    values,
  } = props;

  return requestError ? (
    <div className="row m-0 alert-failed">
        <div className="col-12">
          <p className="text-danger">
            {requestError.message} {requestError.code === 'LOGIN_FAILED_EMAIL_NOT_VERIFIED' && values && (
              <ActivationResend email={values.email as string} />
            )}
          </p>
        </div>
    </div>
  ) : null;
}

const createLoginForm = createForm<LoginModel, CreateFormProps<LoginModel>>({
  className: 'partial-login-form my-0 mx-auto mt-3',
  dispatchData: (dispatch, values: AuthentificationData) => {
    dispatch(loadAuthentification(values as AuthentificationData))
  },
  formFields: loginFormValues(),
  resultKey: 'accessToken',
  shouldRedirect: false,
  stateKeys: 'authentification',
  submitButton: {
    text: formatMessage({...MESSAGES.loginFormButton}),
    className: 'register-button mt-3 w-100'
  }
})(LoginFormResult)

export const LoginForm = connect((state: GlobalState) => ({
  state,
}))(createLoginForm);